// extracted by css-extract-rspack-plugin
export default {"cls1":"useNoClaimsToast-cls1_0-A","cls2":"useNoClaimsToast-cls2_L8G useNoClaimsToast-cls1_0-A"};